import { jsx as _jsx } from "react/jsx-runtime";
import { EditPaymentRequest } from '@src/components/Employee/PaymentRequests/EditPaymentRequest';
import { FullPageWrapper } from '@src/components/FullPageWrapper';
import { prepareItems } from '@src/components/PaymentRequest';
import { ProgramContextProvider } from '@src/contexts/ProgramContextProvider';
import { useAuth } from '@src/hooks/useAuth';
import { usePaymentRequests } from '@src/hooks/usePaymentRequests';
import { PaymentRequestStatus } from '@src/types';
import { LoaderCircleIcon } from 'pe-core-frontend';
import { Navigate, useParams } from 'react-router-dom';
export const EditRequest = () => {
    const { currentUser } = useAuth();
    const { id } = useParams();
    const paymentRequestId = Number(id ?? 0);
    const { loading, find } = usePaymentRequests({ id: paymentRequestId });
    const paymentRequest = find(paymentRequestId);
    if (loading || !paymentRequest) {
        return (_jsx("div", { className: 'mt-2 flex justify-center', children: _jsx(LoaderCircleIcon, {}) }));
    }
    // Employee can edit only their own payment request when it is in ACTIVE or in INFO_REQUESTED status
    if (paymentRequest.program.employeeId !== currentUser?.employeeId ||
        ![
            PaymentRequestStatus.INFO_REQUESTED,
            PaymentRequestStatus.ACTIVE,
            PaymentRequestStatus.AWAITING_DOCUMENTS,
        ].includes(paymentRequest.status)) {
        return _jsx(Navigate, { to: '/', replace: true });
    }
    return (_jsx(FullPageWrapper, { children: _jsx(ProgramContextProvider, { program: paymentRequest.program, children: _jsx(EditPaymentRequest, { paymentRequest: prepareItems(paymentRequest), program: paymentRequest.program }) }) }));
};
